import React from 'react';
import styles from './ResetButton.module.css'; // подключаем стили

const ResetButton = ({ onClick, disabled, title = 'Reset' }) => {
  return (
    <button
      className={styles.resetButton}
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
		<svg width="40px" height="40px" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
		<g fill="none" fill-rule="evenodd" stroke="#0089FF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" transform="matrix(0 1 1 0 2.5 2.5)">
		<path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"/>
		<path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"/>
		</g>
		 </svg>
    </button>	
  );
};

export default ResetButton;

